import * as types from "./actionTypes";
import * as React from "react";
import { VK_COLOR } from "../../services/_locals";


const DEFAULT_BG_IMAGE = "data:image/png;base64,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";

const DEFAULT_AVA_IMAGE = 'data:image/png;base64,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';

const initialState = {
    link: {
        url: '',
    },
    wifi: {
        name: '',
        pass: '',
        wifiType: 1,
    },
    contact: {
        firstName: '',
        midName: '',
        lastName: '',
        position: '',
        company: '',
        phone: '',
        email: '',
        url: '',
    },
    text: {
        text: '',
    },
    event: {
        title: '',
        startDate: '',
        startTimeHours: '',
        startTimeMinutes: '',
        endDate: '',
        endTimeHours: '',
        endTimeMinutes: '',
        description: '',
    },
    geo: {
        text: '',
        position: {
            x: '',
            y: '',
        },
    },
    look: {
        bgImage: DEFAULT_BG_IMAGE,
        isBgLoaded: false,
        bgImageFull: '',
        isBgLoadedFull: false,
        text: '',
        isCounterVisible: false,
        isTextChangedByUser: false,
        selectedStyle1: 1,
        selectedStyle2: 1,
        selectedStyle3: 1,
        selectedType: 1,
        colorPicker: {
            isCode: true,
            isBorder: false,
            isText: false,
            colorCode: '#000000',
            colorText: VK_COLOR,
            colorFontText: '#ffffff',
            colorBg: VK_COLOR,
            colorCodeReal: '#000000',
            colorTextReal: VK_COLOR,
            colorBgReal: VK_COLOR,
        },
    },
    advanced: {
        withImageAndText: false,
        iconSelected: 3,
        isIconSelectedByUser: false,
        iconUploaded: '',
        topIconUploaded: DEFAULT_AVA_IMAGE,
        isTopIconLoaded: false,
        title: '',
        link: '',
    },
    isTooLongQR: false,
};

export const settings = (state = initialState, action) => {

    switch (action.type) {
        case types.SET_LINK_URL:
            return {
                ...state,
                link: {
                    ...state.link,
                    url: action.url,
                },
            };

        case types.SET_WIFI_NAME:
            return {
                ...state,
                wifi: {
                    ...state.wifi,
                    name: action.name,
                },
            };

        case types.SET_WIFI_PASS:
            return {
                ...state,
                wifi: {
                    ...state.wifi,
                    pass: action.pass,
                },
            };

        case types.SET_WIFI_TYPE:
            return {
                ...state,
                wifi: {
                    ...state.wifi,
                    wifiType: action.wifiType,
                },
            };

        case types.SET_CONTACT_FIRST_NAME:
            return {
                ...state,
                contact: {
                    ...state.contact,
                    firstName: action.firstName,
                },
            };

        case types.SET_CONTACT_MID_NAME:
            return {
                ...state,
                contact: {
                    ...state.contact,
                    midName: action.midName,
                },
            };

        case types.SET_CONTACT_LAST_NAME:
            return {
                ...state,
                contact: {
                    ...state.contact,
                    lastName: action.lastName,
                },
            };

        case types.SET_CONTACT_POSITION:
            return {
                ...state,
                contact: {
                    ...state.contact,
                    position: action.position,
                },
            };

        case types.SET_CONTACT_COMPANY:
            return {
                ...state,
                contact: {
                    ...state.contact,
                    company: action.company,
                },
            };

        case types.SET_CONTACT_PHONE:
            return {
                ...state,
                contact: {
                    ...state.contact,
                    phone: action.phone,
                },
            };

        case types.SET_CONTACT_EMAIL:
            return {
                ...state,
                contact: {
                    ...state.contact,
                    email: action.email,
                },
            };

        case types.SET_CONTACT_URL:
            return {
                ...state,
                contact: {
                    ...state.contact,
                    url: action.url,
                },
            };

        case types.SET_TEXT_TEXT:
            return {
                ...state,
                text: {
                    ...state.text,
                    text: action.text,
                },
            };

        case types.SET_EVENT_TITLE:
            return {
                ...state,
                event: {
                    ...state.event,
                    title: action.title,
                },
            };

        case types.SET_EVENT_START_DATE:
            return {
                ...state,
                event: {
                    ...state.event,
                    startDate: action.startDate,
                },
            };

        case types.SET_EVENT_START_TIME_HOURS:
            return {
                ...state,
                event: {
                    ...state.event,
                    startTimeHours: action.startTimeHours,
                },
            };

        case types.SET_EVENT_START_TIME_MINUTES:
            return {
                ...state,
                event: {
                    ...state.event,
                    startTimeMinutes: action.startTimeMinutes,
                },
            };

        case types.SET_EVENT_END_DATE:
            return {
                ...state,
                event: {
                    ...state.event,
                    endDate: action.endDate,
                },
            };

        case types.SET_EVENT_END_TIME_HOURS:
            return {
                ...state,
                event: {
                    ...state.event,
                    endTimeHours: action.endTimeHours,
                },
            };

        case types.SET_EVENT_END_TIME_MINUTES:
            return {
                ...state,
                event: {
                    ...state.event,
                    endTimeMinutes: action.endTimeMinutes,
                },
            };

        case types.SET_EVENT_DESCRIPTION:
            return {
                ...state,
                event: {
                    ...state.event,
                    description: action.description,
                },
            };

        case types.SET_GEO_TEXT:
            return {
                ...state,
                geo: {
                    ...state.geo,
                    text: action.text,
                },
            };

        case types.SET_GEO_POSITION_X:
            return {
                ...state,
                geo: {
                    ...state.geo,
                    position: {
                        ...state.geo.position,
                        x: action.positionX,
                    },
                },
            };

        case types.SET_GEO_POSITION_Y:
            return {
                ...state,
                geo: {
                    ...state.geo,
                    position: {
                        ...state.geo.position,
                        y: action.positionY,
                    },
                },
            };

        case types.SET_LOOK_TEXT:
            return {
                ...state,
                look: {
                    ...state.look,
                    text: action.text,
                    isTextChangedByUser: action.isTextChangedByUser,
                },
            };

        case types.SET_LOOK_SELECTED_TYPE:
            return {
                ...state,
                look: {
                    ...state.look,
                    selectedType: action.selectedType,
                },
            };

        case types.SET_LOOK_STYLE1:
            return {
                ...state,
                look: {
                    ...state.look,
                    selectedStyle1: action.selectedStyle1,
                },
            };

        case types.SET_LOOK_STYLE2:
            return {
                ...state,
                look: {
                    ...state.look,
                    selectedStyle2: action.selectedStyle2,
                },
            };

        case types.SET_LOOK_STYLE3:
            return {
                ...state,
                look: {
                    ...state.look,
                    selectedStyle3: action.selectedStyle3,
                },
            };

        case types.SET_LOOK_COLOR_CODE:
            return {
                ...state,
                look: {
                    ...state.look,
                    colorPicker: {
                        ...state.look.colorPicker,
                        colorCode: action.colorCode,
                    },
                },
            };

        case types.SET_LOOK_COLOR_TEXT:
            return {
                ...state,
                look: {
                    ...state.look,
                    colorPicker: {
                        ...state.look.colorPicker,
                        colorText: action.colorText,
                    },
                },
            };

        case types.SET_LOOK_COLOR_FONT_TEXT:
            return {
                ...state,
                look: {
                    ...state.look,
                    colorPicker: {
                        ...state.look.colorPicker,
                        colorFontText: action.colorFontText,
                    },
                },
            };

        case types.SET_LOOK_COLOR_BG:
            return {
                ...state,
                look: {
                    ...state.look,
                    colorPicker: {
                        ...state.look.colorPicker,
                        colorBg: action.colorBg,
                    },
                },
            };

        case types.SET_LOOK_REAL_COLORS:
            return {
                ...state,
                look: {
                    ...state.look,
                    colorPicker: {
                        ...state.look.colorPicker,
                        colorBgReal: action.colorBg,
                    },
                },
            };

        case types.SET_LOOK_BG_IMG:
            return {
                ...state,
                look: {
                    ...state.look,
                    bgImage: action.bgImage,
                },
            };

        case types.SET_LOOK_BG_LOADED:
            return {
                ...state,
                look: {
                    ...state.look,
                    isBgLoaded: action.isBgLoaded,
                    bgImage: action.isBgLoaded ? state.look.bgImage : DEFAULT_BG_IMAGE,
                },
            };

        case types.SET_LOOK_BG_IMG_FULL:
            return {
                ...state,
                look: {
                    ...state.look,
                    bgImageFull: action.bgImageFull,
                },
            };

        case types.SET_LOOK_BG_LOADED_FULL:
            return {
                ...state,
                look: {
                    ...state.look,
                    isBgLoadedFull: action.isBgLoadedFull,
                    bgImageFull: action.isBgLoadedFull ? state.look.bgImageFull : '',
                },
            };

        case types.SET_CP_IS_CODE:
            return {
                ...state,
                look: {
                    ...state.look,
                    colorPicker: {
                        ...state.look.colorPicker,
                        isCode: action.isCode,
                    }
                },
            };

        case types.SET_CP_IS_BORDER:
            return {
                ...state,
                look: {
                    ...state.look,
                    colorPicker: {
                        ...state.look.colorPicker,
                        isBorder: action.isBorder,
                    }
                },
            };

        case types.SET_CP_IS_TEXT:
            return {
                ...state,
                look: {
                    ...state.look,
                    colorPicker: {
                        ...state.look.colorPicker,
                        isText: action.isText,
                    }
                },
            };

        case types.SET_ADV_WITH_IMAGE_AND_TEXT:
            return {
                ...state,
                advanced: {
                    ...state.advanced,
                    withImageAndText: action.withImageAndText,
                },
            };

        case types.SET_ADV_ICON_SELECTED:
            return {
                ...state,
                advanced: {
                    ...state.advanced,
                    iconSelected: action.iconSelected,
                    isIconSelectedByUser: action.byUser,
                },
            };

        case types.SET_ADV_TITLE:
            return {
                ...state,
                advanced: {
                    ...state.advanced,
                    title: action.title,
                },
            };

        case types.SET_ADV_LINK:
            return {
                ...state,
                advanced: {
                    ...state.advanced,
                    link: action.link,
                },
            };

        case types.SET_ADV_IMG_ICON:
            return {
                ...state,
                advanced: {
                    ...state.advanced,
                    iconUploaded: action.iconUploaded,
                },
            };

        case types.SET_ADV_TOP_IMG_ICON:
            return {
                ...state,
                advanced: {
                    ...state.advanced,
                    topIconUploaded: action.iconUploaded,
                },
            };

        case types.SET_ADV_TOP_IMG_ICON_LOADED:
            return {
                ...state,
                advanced: {
                    ...state.advanced,
                    isTopIconLoaded: action.isTopIconLoaded,
                    topIconUploaded: action.isTopIconLoaded ? state.advanced.topIconUploaded : DEFAULT_AVA_IMAGE,
                },
            };

        case types.SET_IS_TOO_LONG:
            return {
                ...state,
                isTooLongQR: action.isTooLongQR,
            };

        case types.SET_LOOK_COUNTER_VISIBILITY:
            return {
                ...state,
                look: {
                    ...state.look,
                    isCounterVisible: action.isCounterVisible,
                },
            };

        default:
            return state;
    }
};
